module.exports = __WEBPACK_EXTERNAL_MODULE_file_saver_95885b3b__;